// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"fddc3aab","488":"d569f7a0"}[chunkId] + ".chunk.js";
};